import type { SavedFile } from '@frontend/api-types';
import { Clickable, Icon, Text, YStack } from '@frontend/web-react';

type ChatFilePreviewProps = {
  file: SavedFile;
  onClick: (file: SavedFile) => void;
};

export const ChatFilePreview = ({ file, onClick }: ChatFilePreviewProps) => {
  return (
    <Clickable
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="bg-trueWhite border-borderPrimary border-1 rounded-lg gap-sm p-sm max-w-[300px]"
      enableHoverEffect
      flexDirection="row"
      onClick={() => onClick(file)}
    >
      <YStack className="rounded-md p-sm bg-neutral-100">
        <Icon name="IconFile" size={20} />
      </YStack>
      <YStack className="flex-1">
        <Text lineClamp={1} type="h6">
          {file.key}
        </Text>
        <Text color="secondary" type="p-sm">
          {file.contentType}
        </Text>
      </YStack>
    </Clickable>
  );
};
